export default __webpack_public_path__ + "cart-failure.svg?8cae7b99345bca016370571097d054d8";